import { auth } from "./../../../server";
import {
  getDBUser,
  RegisterCustomer,
  updateUser,
} from "../../../api/services/userService.js";
import firebase from "firebase/app";
export default {
  state: {
    user: null,
    dbuser: null,
    showOverlay: false,
    showOverlayLogin: false,
    unsubscribeAutoSignIn: null,
    unsubscribeUserSignIn: null,
    unsubscribeGoogleSignIn: null,
    unsubscribeFacebookSignIn: null,
    unsubscribeUserSignUp: null,
    verificationPhone: null,
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setDBUser(state, payload) {
      state.dbuser = payload;
    },
    setShowOverlay(state, payload) {
      if (typeof payload == "object") {
        state.redirectedFromCheckout = true;
        state.showOverlay = payload.value;
        state.showOverlayLogin = payload.login;
      } else {
        state.showOverlay = payload;
        if (payload == true) {
          state.redirectedFromCheckout = false;
        } else {
          state.verificationPhone = null;
        }
        state.showOverlayLogin = true;
      }

    },
    setShowOverlayLogin(state){
      state.showOverlayLogin = true;
    },
    setVerificationPhone(state, payload) {
      state.verificationPhone = payload;
    },
    setUnsubscribeAutoSignIn(state, payload) {
      state.unsubscribeAutoSignIn = payload;
    },
    setUnsubscribeUserSignIn(state, payload) {
      state.unsubscribeUserSignIn = payload;
    },
    setUnsubscribeGoogleSignIn(state, payload) {
      state.unsubscribeGoogleSignIn = payload;
    },
    setUnsubscribeFacebookSignIn(state, payload) {
      state.unsubscribeFacebookSignIn = payload;
    },
    setUnsubscribeUserSignUp(state, payload) {
      state.unsubscribeUserSignUp = payload;
    },
  },
  actions: {
    async signUserUp({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        auth
          .createUserWithEmailAndPassword(payload.email, payload.password)
          .then(async (user) => {
            // commit("setLoading", false); this line causes an error
            const newUser = {
              id: user.user.uid,
              name: user.user.displayName,
              address: user.user.address,
              phoneNumber: user.user.phoneNumber,
              birthDate: user.user.birthDate,
              email: user.user.email,
              photoUrl: user.user.photoURL,
            };
            commit("setUser", newUser);
            var setUnsubscribeUserSignUp = getDBUser(newUser.id).onSnapshot(
              (dbuser) => {
                if (dbuser.exists)
                  if (dbuser.exists) commit("setDBUser", dbuser.data());
                resolve();
              }
            );
            commit("setUnsubscribeUserSignUp", setUnsubscribeUserSignUp);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async signUserIn({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        auth
          .signInWithEmailAndPassword(payload.email, payload.password)
          .then(async (res) => {
            const newUser = {
              id: res.user.uid,
              name: res.user.displayName,
              email: res.user.email,
              address: res.user.address,
              phoneNumber: res.user.phoneNumber,
              birthDate: res.user.birthDate,
              photoUrl: res.user.photoURL,
              emailVerified: res.user.emailVerified,
            };
            commit("setUser", newUser);
            var unsubscribeUserSignIn = getDBUser(newUser.id).onSnapshot(
              (dbuser) => {
                if (dbuser.exists)
                  if (dbuser.exists) commit("setDBUser", dbuser.data());
                resolve();
              }
            );
            commit("setUnsubscribeUserSignIn", unsubscribeUserSignIn);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async signUserInFacebook({ commit, getters }) {
      return new Promise(async (resolve, reject) => {
        auth
          .signInWithPopup(new firebase.auth.FacebookAuthProvider())
          .then(async (user) => {
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL,
            };
            commit("setUser", newUser);
            var unsubscribeFacebookSignIn = getDBUser(newUser.id).onSnapshot(
              (dbuser) => {
                if (dbuser.exists) {
                  commit("setDBUser", dbuser.data());
                  resolve();
                } else {
                  RegisterCustomer(newUser.id, {
                    Email: newUser.email,
                    FirstName: newUser.name.split(" ")[0],
                    LastName:
                      newUser.name.split(" ")[1] || newUser.name.split(" ")[0],
                    HQCompanyID: getters.currentStoreDoc.HQCompanyID,
                  })
                    .then((response) => {
                      var customerCode = "";
                      if (response.data.Success) {
                        customerCode =
                          response.data.Customer.CustomerMemberCode;
                      }
                      updateUser(newUser.id, {
                        FirstName: newUser.name.split(" ")[0],
                        LastName:
                          newUser.name.split(" ")[1] ||
                          newUser.name.split(" ")[0],
                        DisplayName: newUser.name,
                        FirebaseUDID: newUser.id,
                        Email: newUser.email,
                        CustomerMemberCode: customerCode,
                      })
                        .then(() => {
                          resolve();
                        })
                        .catch(() => {
                          resolve();
                        });
                    })
                    .catch(() => {
                      resolve();
                    });
                }
              }
            );
            commit("setUnsubscribeFacebookSignIn", unsubscribeFacebookSignIn);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async signUserInGoogle({ commit, getters }) {
      return new Promise(async (resolve, reject) => {
        auth
          .signInWithPopup(new firebase.auth.GoogleAuthProvider())
          .then(async (res) => {
            var user = res.user;
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL,
            };
            commit("setUser", newUser);
            var unsubscribeGoogleSignIn = getDBUser(newUser.id).onSnapshot(
              (dbuser) => {
                if (dbuser.exists) {
                  commit("setDBUser", dbuser.data());
                  resolve();
                } else {
                  RegisterCustomer(newUser.id, {
                    Email: newUser.email,
                    FirstName: newUser.name.split(" ")[0],
                    LastName:
                      newUser.name.split(" ")[1] || newUser.name.split(" ")[0],
                    HQCompanyID: getters.currentStoreDoc.HQCompanyID,
                  })
                    .then((response) => {
                      var customerCode = "";
                      if (response.data.Success) {
                        customerCode =
                          response.data.Customer.CustomerMemberCode;
                      }
                      updateUser(newUser.id, {
                        FirstName: newUser.name.split(" ")[0],
                        LastName:
                          newUser.name.split(" ")[1] ||
                          newUser.name.split(" ")[0],
                        DisplayName: newUser.name,
                        FirebaseUDID: newUser.id,
                        Email: newUser.email,
                        CustomerMemberCode: customerCode,
                      })
                        .then(() => {
                          resolve();
                        })
                        .catch(() => {
                          resolve();
                        });
                    })
                    .catch(() => {
                      resolve();
                    });
                }
              }
            );
            commit("setUnsubscribeGoogleSignIn", unsubscribeGoogleSignIn);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async autoSignIn({ commit }, payload) {
      commit("setUser", {
        id: payload.uid,
        name: payload.displayName,
        email: payload.email,
        photoUrl: payload.photoURL,
      });
      var unsubscribeAutoSignIn = getDBUser(payload.uid).onSnapshot(
        (dbuser) => {
          if (dbuser.exists)
            if (dbuser.exists) commit("setDBUser", dbuser.data());
        }
      );
      commit("setUnsubscribeAutoSignIn", unsubscribeAutoSignIn);
    },
    resetPasswordWithEmail(payload) {
      const { email } = payload;
      auth.sendPasswordResetEmail(email).then(() => {
        throw "Email Sent";
      });
    },
    logout({ commit, state }) {
      unsubscribing(state);
      auth.signOut();
      commit("setUser", null);
      commit("setDBUser", null);
    },
  },

  getters: {
    user(state) {
      return state.user;
    },
    dbuser(state) {
      return state.dbuser;
    },
    showOverlay(state) {
      return state.showOverlay;
    },
    showOverlayLogin(state) {
      return state.showOverlayLogin;
    },
    verificationPhone(state) {
      return state.verificationPhone;
    },
  },
};
function unsubscribing(state) {
  if (state.unsubscribeAutoSignIn) state.unsubscribeAutoSignIn();
  if (state.unsubscribeFacebookSignIn) state.unsubscribeFacebookSignIn();
  if (state.unsubscribeGoogleSignIn) state.unsubscribeGoogleSignIn();
  if (state.unsubscribeUserSignIn) state.unsubscribeUserSignIn();
  if (state.unsubscribeUserSignUp) state.unsubscribeUserSignUp();
}
